<template>
    <Card>
        <template v-slot:title>
            {{ __('general.integrations') }}
        </template>
        <template v-slot:toolbar>
            <HelpButton/>
        </template>

        <Errors />

        <h4 class="text-success p-1">
            <i class="fas fa-check-circle"/>
            {{ __('general.active') }}
        </h4>
        <div class="grid-container">
            <div v-for="integration in enabledIntegrations" class="d-flex flex-row">
                <IntegrationCard class="w-100" :integration="integration"/>
            </div>
        </div>

        <div class="py-5">
            <hr>
        </div>

        <h4 class="text-primary mt-5 p-1">
            <i class="fas fa-plus-circle"/>
            {{ __('integrations.available_integrations') }}
        </h4>
        <div class="grid-container">
            <div v-for="integration in disabledIntegrations" class="d-flex flex-row">
                <IntegrationCard class="w-100" :integration="integration"/>
            </div>
        </div>
    </Card>
</template>

<script>
import {PermissionsMixin} from '@js/permissions';
import IntegrationCard from '@components/Integrations/IntegrationCard';
import HelpButton from '@components/HelpButton.vue'
import Card from "@components/Cards/Card.vue";
import Errors from "@components/Errors.vue";

export default {
    components: {
        Errors,
        Card,
        HelpButton,
        IntegrationCard,
    },

    mixins: [PermissionsMixin],

    props: {
        integrations: Array,
    },

    computed: {
        enabledIntegrations() {
            return this.visibleIntegrations.filter(integration => integration.enabled);
        },

        disabledIntegrations() {
            return this.visibleIntegrations.filter(integration => !integration.enabled);
        },

        visibleIntegrations() {
            let visible = [];
            for (let integration of this.integrations) {
                if (integration.visible || integration.enabled || this.Permission.ACCESS_ADMIN_PANEL) {
                    visible.push(integration);
                }
            }
            return visible;
        },
    },
};
</script>

<style scoped>
.grid-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-auto-rows: max-content;
    gap: 8px;
}

.grid-container div {
    min-height: 160px;
}

@media (min-width: 722px) {
    .grid-container {
        grid-template-columns: 1fr 1fr;
    }
}

@media (min-width: 1200px) {
    .grid-container {
        grid-template-columns: 1fr 1fr 1fr;
    }
}
</style>
